import UserSidebarView from './UserSidebarView';
import useUserSidebarData from './useUserSidebarData';

type UserSidebarProps = {
  id: string;
  onClose: () => void;
};

const UserSidebar = ({ id, onClose }: UserSidebarProps) => {
  const { user, workOrders, loading, error } = useUserSidebarData(id);

  return (
    <UserSidebarView
      user={user}
      workOrders={workOrders}
      loading={loading}
      error={error}
      onClose={onClose}
    />
  );
};

export default UserSidebar;
